function Footer(props) {
    return <h1></h1>;
  }
  
  export default Footer;
  
  